
import { Component, Vue } from "vue-property-decorator"

@Component
export default class TDNull extends Vue {
    static componentName = "TDNull"
}
